import ProductPageCompanyMenu from './product-page-company-menu';
export default ProductPageCompanyMenu;